import { render, staticRenderFns } from "./ProjectDetailsModal.vue?vue&type=template&id=499be3fb&scoped=true&"
import script from "./ProjectDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectDetailsModal.vue?vue&type=style&index=1&id=499be3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499be3fb",
  null
  
)

export default component.exports